export const MIN_DAYS_FROM_NOW = 0;
export const SCREEN_TITLE = "Bảo hiểm bắt buộc TNDS xe ô tô";

export const MOCK_TNDS_CAR_TITLE = "Bảo hiểm bắt buộc TNDS chủ xe ô tô";
export const MOCK_TNDS_CAR_BULLETS = [
  "Mức trách nhiệm về người: 150.000.000đ/người/vụ",
  "Mức trách nhiệm về tài sản: 100.000.000đ/vụ",
  "Thời hạn bảo hiểm: 1 năm (bắt buộc theo quy định nhà nước)",
  "Cấp giấy chứng nhận điện tử nhanh chóng, hợp lệ 100% khi lưu thông",
];

export const MOCK_CAR_RULES_TITLE = "Quy tắc bảo hiểm TNDS xe ô tô";
export const MOCK_CAR_RULES_BULLETS = [
  "Áp dụng theo Nghị định 67/2023/NĐ-CP quy định về bảo hiểm bắt buộc TNDS của chủ xe cơ giới.",
  "Bồi thường các thiệt hại ngoài hợp đồng về sức khỏe, tính mạng và tài sản đối với bên thứ ba do xe cơ giới gây ra.",
  "Hồ sơ bồi thường đơn giản, hỗ trợ khai báo bồi thường online 24/7.",
];

export const BENEFIT_SHEET_TABS = {
  detail: "detail",
  rules: "rules",
};

export const ACCIDENT_INSURANCE_OPTIONS = [
  { code: "0", name: "Không", nameWithType: "Không" },
  { code: "10", name: "10.000.000 VNĐ/người/vụ", nameWithType: "10.000.000 VNĐ/người/vụ" },
  // { code: "20", name: "20.000.000 VNĐ/người/vụ", nameWithType: "20.000.000 VNĐ/người/vụ" },
  // { code: "50", name: "50.000.000 VNĐ/người/vụ", nameWithType: "50.000.000 VNĐ/người/vụ" },
  // { code: "100", name: "100.000.000 VNĐ/người/vụ", nameWithType: "100.000.000 VNĐ/người/vụ" },
];

export const PROVINCE_FALLBACK_LIST = [
  { code: "79", name: "Thành phố Hồ Chí Minh", nameWithType: "Thành phố Hồ Chí Minh" },
  { code: "01", name: "Thành phố Hà Nội", nameWithType: "Thành phố Hà Nội" },
  { code: "48", name: "Thành phố Đà Nẵng", nameWithType: "Thành phố Đà Nẵng" },
  { code: "31", name: "Thành phố Hải Phòng", nameWithType: "Thành phố Hải Phòng" },
  { code: "92", name: "Thành phố Cần Thơ", nameWithType: "Thành phố Cần Thơ" },
  { code: "46", name: "Tỉnh Thừa Thiên Huế", nameWithType: "Tỉnh Thừa Thiên Huế" },
  { code: "60", name: "Tỉnh Đồng Nai", nameWithType: "Tỉnh Đồng Nai" },
  { code: "74", name: "Tỉnh Bình Dương", nameWithType: "Tỉnh Bình Dương" },
  { code: "77", name: "Tỉnh Bà Rịa - Vũng Tàu", nameWithType: "Tỉnh Bà Rịa - Vũng Tàu" },
  { code: "68", name: "Tỉnh Lâm Đồng", nameWithType: "Tỉnh Lâm Đồng" },
  { code: "56", name: "Tỉnh Khánh Hòa", nameWithType: "Tỉnh Khánh Hòa" },
  { code: "36", name: "Tỉnh Nam Định", nameWithType: "Tỉnh Nam Định" },
  { code: "37", name: "Tỉnh Ninh Bình", nameWithType: "Tỉnh Ninh Bình" },
  { code: "22", name: "Tỉnh Quảng Ninh", nameWithType: "Tỉnh Quảng Ninh" },
  { code: "24", name: "Tỉnh Bắc Giang", nameWithType: "Tỉnh Bắc Giang" },
  { code: "27", name: "Tỉnh Bắc Ninh", nameWithType: "Tỉnh Bắc Ninh" },
  { code: "30", name: "Tỉnh Hải Dương", nameWithType: "Tỉnh Hải Dương" },
  { code: "33", name: "Tỉnh Hưng Yên", nameWithType: "Tỉnh Hưng Yên" },
  { code: "34", name: "Tỉnh Thái Bình", nameWithType: "Tỉnh Thái Bình" },
  { code: "35", name: "Tỉnh Hà Nam", nameWithType: "Tỉnh Hà Nam" },
  { code: "38", name: "Tỉnh Thanh Hóa", nameWithType: "Tỉnh Thanh Hóa" },
  { code: "40", name: "Tỉnh Nghệ An", nameWithType: "Tỉnh Nghệ An" },
  { code: "42", name: "Tỉnh Hà Tĩnh", nameWithType: "Tỉnh Hà Tĩnh" },
  { code: "44", name: "Tỉnh Quảng Bình", nameWithType: "Tỉnh Quảng Bình" },
  { code: "45", name: "Tỉnh Quảng Trị", nameWithType: "Tỉnh Quảng Trị" },
  { code: "51", name: "Tỉnh Quảng Nam", nameWithType: "Tỉnh Quảng Nam" },
  { code: "52", name: "Tỉnh Quảng Ngãi", nameWithType: "Tỉnh Quảng Ngãi" },
  { code: "54", name: "Tỉnh Bình Định", nameWithType: "Tỉnh Bình Định" },
  { code: "58", name: "Tỉnh Ninh Thuận", nameWithType: "Tỉnh Ninh Thuận" },
  { code: "62", name: "Tỉnh Bình Thuận", nameWithType: "Tỉnh Bình Thuận" },
  { code: "80", name: "Tỉnh Long An", nameWithType: "Tỉnh Long An" },
  { code: "82", name: "Tỉnh Tiền Giang", nameWithType: "Tỉnh Tiền Giang" },
  { code: "83", name: "Tỉnh Bến Tre", nameWithType: "Tỉnh Bến Tre" },
  { code: "84", name: "Tỉnh Trà Vinh", nameWithType: "Tỉnh Trà Vinh" },
  { code: "86", name: "Tỉnh Vĩnh Long", nameWithType: "Tỉnh Vĩnh Long" },
  { code: "87", name: "Tỉnh Đồng Tháp", nameWithType: "Tỉnh Đồng Tháp" },
  { code: "89", name: "Tỉnh An Giang", nameWithType: "Tỉnh An Giang" },
  { code: "91", name: "Tỉnh Kiên Giang", nameWithType: "Tỉnh Kiên Giang" },
  { code: "93", name: "Tỉnh Hậu Giang", nameWithType: "Tỉnh Hậu Giang" },
  { code: "94", name: "Tỉnh Sóc Trăng", nameWithType: "Tỉnh Sóc Trăng" },
  { code: "95", name: "Tỉnh Bạc Liêu", nameWithType: "Tỉnh Bạc Liêu" },
  { code: "96", name: "Tỉnh Cà Mau", nameWithType: "Tỉnh Cà Mau" },
];

export const benefitSheetModalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(20, 43, 67, 0.5)",
    zIndex: 200,
  },
  content: {
    top: "auto",
    left: "auto",
    right: "auto",
    bottom: 0,
    margin: "0 auto",
    padding: 0,
    width: "100%",
    maxWidth: "100%",
    maxHeight: "85vh",
    border: "none",
    borderRadius: "16px 16px 0 0",
    overflow: "hidden",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    boxSizing: "border-box",
  },
};
